import React, { FC, FormEvent } from 'react';
import { FormikValues } from 'formik';
import { dashboardElementsOptions } from '../../constants/dashboardConstants';
import { DashboardElementInterface } from '../../interfaces/dashboardElement.interface';
import AutoCompleteInput from '../inputs/autoCompleteInput';

interface AddNewElementSelectInterface {
  formik: FormikValues,
  layout?: DashboardElementInterface[],
}

const AddNewElementSelect: FC<AddNewElementSelectInterface> = (props) => (
  <AutoCompleteInput
    key="element"
    name="element"
    label="dashboardElement"
    placeholder="dashboardElement"
    size="small"
    options={Object.keys(dashboardElementsOptions).filter((key) => (!props.layout?.some((item) => item.i === key)))}
    getOptionLabel={(key) => dashboardElementsOptions?.[key]?.label || ''}
    onChange={(event: FormEvent, value: string) => props.formik.setFieldValue('element', value)}
    error={Boolean(props.formik?.touched.element) && Boolean(props.formik?.errors.element)}
    helperText={Boolean(props.formik?.touched.element) && props.formik?.errors.element}
  />
);

export default AddNewElementSelect;
